<ng-container *ngIf="game">
  <div class="header" [ngStyle]="{backgroundImage: 'url(' + tournamentBg + ')'}">
    <div class="info">
      <div class="name">{{ tournament.name }}</div>
    </div>
    <a [routerLink]="getGameRoute(game.id)" class="btn-detail">Перейти</a>
  </div>
  <div class="game-card">
    <div class="content">
      <div class="team">
        <a [routerLink]="getTeamRoute(game.team.id)" [queryParams]="{season_id: tournament.season.id}" class="logo">
          <mtg-svg-icon class="award-left" icon="custom-award-left" *ngIf="game.teamWinnerId === game.team.id"></mtg-svg-icon>
          <img [src]="game.team.logo.path" *ngIf="game.team.logo.path">
          <div [ngClass]="game.team.getEmptyLogoClass()" *ngIf="!game.team.logo.path"></div>
          <mtg-svg-icon class="award-right" icon="custom-award-right" *ngIf="game.teamWinnerId === game.team.id"></mtg-svg-icon>
        </a>
      </div>
      <div class="center">
        <div class="score">
          <span>{{ game.teamScore }}</span>
          <span class="divider">:</span>
          <span>{{ game.competitorTeamScore }}</span>
        </div>
      </div>
      <div class="team">
        <a [routerLink]="getTeamRoute(game.competitorTeam.id)" [queryParams]="{season_id: tournament.season.id}" class="logo">
          <mtg-svg-icon class="award-left" icon="custom-award-left" *ngIf="game.teamWinnerId === game.competitorTeam.id"></mtg-svg-icon>
          <img [src]="game.competitorTeam.logo.path" *ngIf="game.competitorTeam.logo.path">
          <div [ngClass]="game.competitorTeam.getEmptyLogoClass()" *ngIf="!game.competitorTeam.logo.path"></div>
          <mtg-svg-icon class="award-right" icon="custom-award-right" *ngIf="game.teamWinnerId === game.competitorTeam.id"></mtg-svg-icon>
        </a>
      </div>
    </div>
    <div class="footer">
      <div class="court">
        <mtg-svg-icon icon="icons-pin"></mtg-svg-icon>
        {{ game.tournamentCourt.name }}
      </div>
      <div class="time">
        {{ game.datetime | date: 'dd MMM' }} {{ game.datetime | date: 'HH:mm' }}
      </div>
    </div>
  </div>
</ng-container>
